import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import { AuthContext } from "context/AuthContext";
import { useContext, useEffect, useMemo, useState } from "react";
import { navLinks } from "./nav-links";
import { USER_ROLE } from "lib/constants";

export default function NavLinks() {
  const location = useLocation();
  const { pathname } = location;

  const { user } = useContext(AuthContext);
  const userRole = user.role;
  let links = navLinks[userRole] || [];
  // TODO Temporary logic, solve online problems first
  if (userRole === USER_ROLE.Dealer && !user?.organization?.enableMonitoring) {
    links = links.filter((link) => link.name !== "Shift");
  }
  const [firtstIndex, setFirstIndex] = useState(0);
  const [maxRollIndex, setMaxRollIndex] = useState(10);

  const filterLinks = useMemo(() => {
    const _firstIndex = firtstIndex;
    return links.slice(_firstIndex, _firstIndex + maxRollIndex);
  }, [firtstIndex, maxRollIndex]);

  useEffect(() => {
    const calMaxShowCount = () => {
      let availableLen = window.innerHeight;
      if (window.innerWidth < 768) {
        availableLen = window.innerHeight - 150;
      } else {
        availableLen = availableLen - 250;
      }
      const maxShowCount = Math.floor(availableLen / 48);
      console.log("maxShowCount", maxShowCount);
      setMaxRollIndex(maxShowCount);
    };
    window.addEventListener("resize", calMaxShowCount);
    calMaxShowCount();
    return () => {
      window.removeEventListener("resize", calMaxShowCount);
    };
  }, []);

  return (
    <div
      className="flex flex-ro md:flex-col md:space-y-2"
      onWheel={(e) => {
        const direction = e.deltaY > 0 ? "down" : "up";
        console.log("scrolling", direction);
        if (direction === "down") {
          setFirstIndex((pre) => {
            if (pre + 1 > links.length - maxRollIndex) {
              return pre;
            }
            return pre + 1;
          });
        }
        if (direction === "up") {
          setFirstIndex((pre) => {
            if (pre - 1 < 0) {
              return pre;
            }
            return pre - 1;
          });
        }
      }}
    >
      {firtstIndex > 0 && (
        <div className="border h-full md:w-full border-[#E1E1E1]" />
      )}
      {filterLinks.map((link: any) => {
        const LinkIcon: any = link.icon;
        let selected = false;

        if (link.href === "/dashboard") {
          if (pathname === link.href) {
            selected = true;
          }
        } else if (pathname.includes(link.href)) {
          selected = true;
        } else if (link.subMenu?.length) {
          link.subMenu?.forEach((item) => {
            if (pathname.includes(item.href)) {
              selected = true;
            }
          });
        }

        return link.subMenu?.length ? (
          <div
            key={link.name}
            className={clsx(
              "relative menuLink group flex h-[48px] w-[48px] md:w-fit grow items-center justify-center gap-3 rounded-full text-sm font-medium md:flex-none md:justify-start md:px-3",
            )}
          >
            <div
              className={clsx("subMenus relative ", {
                selected: selected,
              })}
            >
              <div className="m-3">
                <LinkIcon width="22" className="fill-neutral-800 LinkIcon" />
              </div>
              <div
                className={clsx("subMenuContent", {
                  selected: selected,
                })}
              >
                <p
                  style={{ textWrap: "nowrap" }}
                  className={clsx("subTitle", {
                    selected: selected,
                  })}
                >
                  {link.name}
                </p>
                {link.subMenu.map((item) => (
                  <Link
                    key={item.href}
                    to={item.href}
                    className={clsx("subLink", {
                      subLinkSelected: pathname === item.href,
                    })}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <Link
            key={link.name}
            to={link.href || ""}
            className={clsx(
              "relative menuLink min-w-[46px] w-fit  group flex h-[48px] grow items-center justify-center z-10 gap-3 rounded-full text-sm font-medium md:flex-none md:justify-start  md:px-3",
              selected
                ? "bg-blue-100 hover:bg-blue-100 selected"
                : "hover:bg-zinc-100",
            )}
          >
            <div className="linkTitle">
              <LinkIcon width="22" className="fill-neutral-800 LinkIcon" />
              <p className="title" style={{ textWrap: "nowrap" }}>
                {link.name}
              </p>
            </div>
          </Link>
        );
      })}
      {links.length > maxRollIndex &&
        firtstIndex + maxRollIndex < links.length && (
          <div className="border h-full md:w-full border-[#E1E1E1]" />
        )}
    </div>
  );
}
